import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { BizTargetType } from '@/constants/bizTargetType';
import { DatePickerType } from '@/constants/datePicker';
import { STATS_USAGE_REGISTER_NAME } from '@/pages/:AUTH_INFO_ID/stats/usage/constants/registerName';
import { useAuthStore } from '@/store/auth';

export const MONTHLY_FORMAT = 'YYYY-MM';
export const DAILY_FORMAT = 'YYYY-MM-DD';

export const YESTERDAY_DATE_FORMATTED = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
export const PREV_MONTH_FORMATTED = dayjs().subtract(1, 'month').format('YYYY-MM');

const getFormattedString = ({ datePickerType, target }: { datePickerType: DatePickerType; target: string | null }) => {
  const date = dayjs(target);
  const formatStr = datePickerType === DatePickerType.MONTHLY ? MONTHLY_FORMAT : DAILY_FORMAT;
  const fallback = datePickerType === DatePickerType.MONTHLY ? PREV_MONTH_FORMATTED : YESTERDAY_DATE_FORMATTED;

  return date.isValid() ? date.format(formatStr) : fallback;
};

export const useUsageSearchParams = () => {
  const [searchParams] = useSearchParams();
  const { bizTargetType, partnerName } = useAuthStore();

  const datePickerTypeParam = searchParams.get(STATS_USAGE_REGISTER_NAME.DATE_PICKER_TYPE);
  const datePickerType = datePickerTypeParam === DatePickerType.MONTHLY ? DatePickerType.MONTHLY : DatePickerType.DAILY;

  const rawStart = searchParams.get(STATS_USAGE_REGISTER_NAME.START);
  const rawEnd = searchParams.get(STATS_USAGE_REGISTER_NAME.END);
  const start = getFormattedString({ datePickerType, target: rawStart });
  const end = getFormattedString({ datePickerType, target: rawEnd });

  const isPartnerType = bizTargetType !== BizTargetType.DEALER;
  const companyName = searchParams.get(STATS_USAGE_REGISTER_NAME.COMPANY_NAME) || (isPartnerType && partnerName) || '';

  const svcName = searchParams.get(STATS_USAGE_REGISTER_NAME.SVC_NAME) || '';

  return {
    [STATS_USAGE_REGISTER_NAME.DATE_PICKER_TYPE]: datePickerType,
    [STATS_USAGE_REGISTER_NAME.START]: start,
    [STATS_USAGE_REGISTER_NAME.END]: end,
    [STATS_USAGE_REGISTER_NAME.COMPANY_NAME]: companyName,
    [STATS_USAGE_REGISTER_NAME.SVC_NAME]: svcName
  };
};
